export default "__VITE_ASSET__BRU6oxof__"